import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { useTranslation } from 'react-i18next';
import { colorPalette } from '@repo/mui-config/color-palette';
import { Button } from '@repo/ui';
import { activityType } from '@repo/shared/types';
import { useEventClick } from '@repo/hooks';

import { useLoanProcessModal } from '@/components/loan-process/hooks/use-loan-process-modal';
import { MODAL_STATE, useModalStore } from '@/components/modal/modal.store';
import { useMainHubStoreState } from '@/store/main-hub.store';

import { useHandleMakeNewApplication } from './loan-action-card-builder/use-handle-make-new-application';

export function LoanActionCardModal() {
  const { openModal } = useModalStore();
  const { t } = useTranslation();
  const { openLoanModalOnCurrentLoanStage } = useLoanProcessModal();
  const { resetModalStore } = useModalStore();
  const { merchantResponseData } = useMainHubStoreState();
  const trackClick = useEventClick(merchantResponseData);

  const { onClick } = useHandleMakeNewApplication(merchantResponseData);

  const handleOnCancelSuccess = () => {
    onClick();
    resetModalStore();
  };

  const handleFinishCurrentApplication = () => {
    resetModalStore();
    openLoanModalOnCurrentLoanStage();
  };

  const handleCancelLoan = () => {
    openModal(MODAL_STATE.LOAN_CANCEL, undefined, {
      handleOnCancelSuccess,
      handleFinishCurrentApplication,
    });
  };

  return (
    <Stack
      data-testid="loan-action-card"
      alignItems="center"
      sx={{ marginInline: '22px', marginTop: '50px' }}
    >
      <Typography color={colorPalette.ink.main} sx={{ mb: 1 }} variant="h5">
        {t('dashboard.loanActionCard.modal.title')}
      </Typography>
      <Box
        height="86px"
        sx={{
          marginBottom: '32px',
          marginTop: '0px',
        }}
      >
        <Typography
          color={colorPalette.ink.main}
          lineHeight="16px"
          textAlign="center"
          variant="body1"
        >
          {t('dashboard.loanActionCard.modal.subtitle')}
        </Typography>
      </Box>
      <Stack gap="10px" width="100%">
        <Button
          data-testid="button-make-new-application"
          color="secondary"
          onClick={() => {
            trackClick({ activity: activityType.enum.DASHBOARD_NEW_LOAN });
            handleCancelLoan();
          }}
          sx={{ paddingY: '12px' }}
          variant="contained"
        >
          {t('dashboard.loanActionCard.buttons.makeNewApplication')}
        </Button>
        <Button
          color="primary"
          onClick={() => {
            trackClick({ activity: activityType.enum.DASHBOARD_CONTINUE_LOAN });
            handleFinishCurrentApplication();
          }}
          sx={{
            alignItems: 'center',
            paddingY: '12px',
            color: colorPalette.ink.main,
          }}
          variant="text"
        >
          {t('dashboard.loanActionCard.modal.finishCurrentApplication')}
        </Button>
      </Stack>
    </Stack>
  );
}
